module.exports = __webpack_public_path__ + "img/skull_9_bj.8f88fa60.png";